module.exports = __webpack_public_path__ + "img/logo-text.945037c0.svg";